import { BlankState } from "../BotAnalyticsDashboard";
import { Spinner } from "@swivl-mono/ui";
import { transformRatingDataForChart, calculateAverageRating } from "../Helpers/ReviewDataHelpers";
import { BarAndPieChart } from "../../Charts/BarAndPieChart/BarAndPieChart";
import { useEffect } from "react";

export const RatingSummary = ({ reviewData, loadReviewData }) => {
    // Load review data on component mount if not already loaded
    useEffect(() => {
        if (!reviewData) {
            loadReviewData();
        }
    }, [reviewData, loadReviewData]);

    let content, averageRating = "";

    if (reviewData && reviewData.byDateTime) {
        if (Object.keys(reviewData.byDateTime).length === 0) {
            content = <div className="loadingContent">{BlankState()}</div>;
        } else {
            const reviews = Object.values(reviewData.byDateTime).flatMap((day: any) => day.reviews);
            const chartData = transformRatingDataForChart(reviews);
            averageRating = calculateAverageRating(reviews);

            content = (
                <div className="barAndPieWapper">
                    <BarAndPieChart data={chartData} showTotals={true} width={580} height={200} />
                </div>
            );
        }
    } else {
        content = (
            <div className="loadingContent">
                <Spinner />
            </div>
        );
    }

    return (
        <div className="chartBox">
            <div className="chartHeader">
                <div className="chartHeaderTitle">
                    <span>Rating Summary</span>
                </div>
                <div className="spacer" />
                <div className="headerTotal">Average: {averageRating} ⭐️</div>
            </div>
            <div className="chartContent">{content}</div>
        </div>
    );
};